import { Routes } from "@angular/router";
import { authGuard } from "./core/guards/auth/auth.guard";
import { permissionGuard } from "./core/guards/permission/permission.guard";
import { builderAccessGuard } from "./core/guards/builder-access/builder-access.guard";
import { noAuthGuard } from "./core/guards/no-auth/no-auth.guard";
import { onboardingGuard } from "./core/guards/onboarding/onboarding.guard";
import { AppLayout } from "./layouts/app-layout";
import { AuthLayout } from "./layouts/auth-layout";

export const routes: Routes = [
  {
    path: "forms/public/:formId",
    loadComponent: () =>
      import("./pages/formiq/pages/public-form/public-form.component").then(
        (m) => m.PublicFormComponent,
      ),
  },
  {
    path: "project/:slug",
    loadComponent: () =>
      import("./pages/project-micro-link-public/project-micro-link-public-page.component").then(
        (m) => m.ProjectMicroLinkPublicPageComponent,
      ),
  },
  {
    path: "digilocker-complete",
    loadComponent: () =>
      import("./pages/digilocker-complete/digilocker-complete.component").then(
        (m) => m.DigilockerCompleteComponent,
      ),
    title: "DigiLocker",
  },
  {
    path: "ip-blocked",
    loadComponent: () =>
      import("./pages/ip-blocked/ip-blocked.component").then(
        (m) => m.IpBlockedComponent,
      ),
    title: "Access Denied",
  },
  {
    path: "access-restricted",
    loadComponent: () =>
      import("./pages/access-restricted/access-restricted.component").then(
        (m) => m.AccessRestrictedComponent,
      ),
    title: "Access Restricted",
  },
  {
    path: "auth",
    component: AuthLayout,
    canActivate: [noAuthGuard],
    loadChildren: () =>
      import("./modules/auth/auth.routes").then((m) => m.authRoutes),
  },
  {
    path: "onboarding",
    component: AuthLayout,
    canActivate: [onboardingGuard],
    loadChildren: () =>
      import("./modules/onboarding/onboarding.routes").then(
        (m) => m.onboardingRoutes,
      ),
  },
  {
    path: "",
    component: AppLayout,
    canActivate: [authGuard, builderAccessGuard],
    canActivateChild: [permissionGuard],
    children: [
      {
        path: "",
        loadChildren: () =>
          import("./pages/pages.route").then((m) => m.PageRouting),
      },
    ],
  },
];
